<ng-template [spinnerLoader]="vendorsResource.isLoading()" [size]="'sm'"></ng-template>

<label for="producerFilter" class="form-label">Produttore</label>
<select id="producerFilter" class="form-select" [value]="value()" [disabled]="disabled()" (change)="onSelectionChange($event)" (blur)="onBlur()" [class.is-invalid]="isInvalid()">
    <option value="">Tutti i tipi</option>
    @for (item of vendorsResource.value(); track $index) {
        <option [value]="item.id">{{item.name}}</option>
    }
</select>
@for (error of errors(); track $index) {
    <div class="invalid-feedback">{{ error.message }}</div>
}